var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 10.9566C7.50874 10.9566 7.35081 10.8984 7.22613 10.7737L2.18078 5.72835C1.93974 5.48731 1.93974 5.08833 2.18078 4.84729C2.42183 4.60624 2.8208 4.60624 3.06185 4.84729L7.66667 9.45211L12.2715 4.84729C12.5125 4.60624 12.9115 4.60624 13.1525 4.84729C13.3936 5.08833 13.3936 5.48731 13.1525 5.72835L8.1072 10.7737C7.98252 10.8984 7.82459 10.9566 7.66667 10.9566Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.48aee32d74e82789adcf8333f3fa46a4.svg";
export { ForwardRef as ReactComponent };